<div class="add-container">
	<h1 class="add-title">Actualizare template document</h1>
	<form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
		<div class="row">
			<div class="col-md-4">
				<p>Adresă</p>
				<mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onAdresaChange($event)"
					formControlName="is_address">
					<mat-button-toggle [value]="true">Da</mat-button-toggle>
					<mat-button-toggle [value]="false">Nu</mat-button-toggle>
				</mat-button-toggle-group>
			</div>
			<div class="col-md-4">
				<p>Registru Oficial</p>
				<mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onRegistruChange($event)"
					formControlName="registru_necessary">
					<mat-button-toggle [value]="true">Da</mat-button-toggle>
					<mat-button-toggle [value]="false">Nu</mat-button-toggle>
				</mat-button-toggle-group>
			</div>
			<div class="col-md-4">
				<p>Exemplare diferite?</p>
				<mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onDualChange($event)"
					formControlName="document_generabil_dual">
					<mat-button-toggle [value]="true">Da</mat-button-toggle>
					<mat-button-toggle [value]="false">Nu</mat-button-toggle>
				</mat-button-toggle-group>
			</div>
		</div>
		<br />
		<div class="row">
			<div class="col">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Tip Cerere/Document</mat-label>
					<mat-select formControlName="type_id">
						<mat-option *ngFor="let row of cereriTypes$ | async" [value]="row.id">
							{{ row.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Denumire</mat-label>
					<input type="text" matInput formControlName="name" />
					<mat-error *ngIf="
              !form.controls['name'].valid && form.controls['name'].touched
            ">
						Câmp obligatoriu
					</mat-error>
				</mat-form-field>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Registru</mat-label>
					<mat-select formControlName="registru_id">
						<mat-option *ngFor="let row of registre$ | async" [value]="row.id">
							{{ row.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
		<div>
			<mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onDestinatieChange($event)"
				formControlName="destination">
				<mat-button-toggle value="toPrimarie">Exemplar Semnatari</mat-button-toggle>
				<mat-button-toggle *ngIf="form.get('document_generabil_dual')?.value == true" value="toCetatean">Exemplar
					Cetățean</mat-button-toggle>
				<mat-button-toggle *ngIf="form.get('document_generabil_dual')?.value == true" value="toate">Toate</mat-button-toggle>
			</mat-button-toggle-group>
		</div>
		<br />
		<div class="row">
			<div class="col" *ngIf="destination == 'toPrimarie' || destination == 'toate'">
				<br />
				<div class="col">
					<h2 class="fw-bold">Exemplar Semnatari</h2>
					<br />
					<angular-editor class="fit-screen" formControlName="context"
						[config]="editorConfig"></angular-editor>
				</div>
			</div>
			<div class="col" *ngIf="destination == 'toCetatean' || destination == 'toate'">
				<br />
				<div class="col">
					<h2 class="fw-bold">Exemplar Cetățean</h2>
					<br />
					<angular-editor class="fit-screen" formControlName="context_cetatean"
						[config]="editorConfig"></angular-editor>
				</div>
			</div>
		</div>

		<div class="row mt-2">
			<div class="col d-flex justify-content-between">
				<button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
					{{ helper.dialogConfig.buttonLabels.close }}
				</button>
				<button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
					{{ helper.dialogConfig.buttonLabels.save }}
				</button>
			</div>
		</div>
	</form>
	<div class="section-spinner position-absolute" *ngIf="isLoading">
		<div class="spinner position-absolute top-50 start-50 translate-middle">
			<mat-spinner></mat-spinner>
			<h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
		</div>
	</div>
</div>